import { z } from 'zod';
import { apiClient } from '@/core/api/client';
import { ENDPOINTS } from '@/core/api/endpoints';
import { EmpleadoSchema, PromotorSchema, PuntoEncuentroSchema, PuntoVentaSchema, SucursalSchema, TarifaSchema, } from '@/data/dto/catalogos';
/**
 * Algunos endpoints devuelven `{items: [...]}`, otros un array suelto.
 * Normalizamos siempre a array.
 */
function desenvolver(data, schema) {
    if (Array.isArray(data))
        return z.array(schema).parse(data);
    const parsed = z.object({ items: z.array(schema) }).safeParse(data);
    if (parsed.success)
        return parsed.data.items;
    return [];
}
export const catalogosApi = {
    async sucursales() {
        const res = await apiClient.get(ENDPOINTS.sucursales);
        return desenvolver(res.data, SucursalSchema);
    },
    async puntosVentaDeSucursal(sucursalId) {
        const res = await apiClient.get(`${ENDPOINTS.sucursales}/${sucursalId}/puntos-venta`);
        return desenvolver(res.data, PuntoVentaSchema);
    },
    async puntosEncuentroDeSucursal(sucursalId) {
        const res = await apiClient.get(`${ENDPOINTS.sucursales}/${sucursalId}/puntos-encuentro`);
        return desenvolver(res.data, PuntoEncuentroSchema);
    },
    async tarifasDeSucursal(sucursalId) {
        const res = await apiClient.get(`${ENDPOINTS.sucursales}/${sucursalId}/tarifas`);
        return desenvolver(res.data, TarifaSchema);
    },
    async empleados(filtros) {
        const res = await apiClient.get(ENDPOINTS.empleados, {
            params: { disciplina: filtros?.disciplina || undefined, porPagina: 100 },
        });
        return desenvolver(res.data, EmpleadoSchema);
    },
    async promotores() {
        const res = await apiClient.get(ENDPOINTS.promotores);
        return desenvolver(res.data, PromotorSchema);
    },
};
